module.exports = __webpack_public_path__ + "img/spider-friends.81b5bc1e.svg";